/**
 * Wraps the Duration `numberStepper` and disables its decrement (−15)
 * button once the value is at/under {@link DURATION_DECREMENT_FLOOR}.
 * Stepping by 15 would otherwise drop below the meaningful floor; values
 * under it (down to the 5-min min) stay reachable by typing.
 *
 * Reads the live value via RHF `useWatch` — FormBuilder mounts fields
 * inside its FormProvider, so no `control` is needed. CSS-disables the
 * button (kula-ai's NumberStepper labels it "Decrease value") to mirror
 * the atom's native `disabled:opacity-40` look.
 */
import type { ReactNode } from 'react';
import { useWatch } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import { shouldLockDecrement } from './durationDecrement';

export function DurationDecrementGate({ children }: { children: ReactNode }) {
  const value = useWatch({ name: 'duration' });
  const lockDecrement = shouldLockDecrement(value);

  return (
    <Box
      sx={
        lockDecrement
          ? {
              '& [aria-label="Decrease value"]': {
                pointerEvents: 'none',
                opacity: 0.4,
              },
            }
          : undefined
      }
    >
      {children}
    </Box>
  );
}
